import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ConfigureStore from './MainComponents/Store/ConfigureStore';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <Provider store={ConfigureStore}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
      <Toaster
          position="top-center"
          toastOptions={{
            success: {
              style: {
                fontSize: "16px",
                marginTop: "14px",
                color: "white",
                background: "#3fb172",
                padding: "10px",
              },
            },
            error: {
              style: {
                fontSize: "16px",
                marginTop: "14px",
                color: "white",
                background: "#ff0000",
                padding: "10px",
              },
            },
          }}
        />
       <App/>
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
